import axios from 'axios';
import { getApiUrl } from '../config/environment';

const API_URL = getApiUrl();

export interface HostingPackage {
  id: string;
  name: string;
  description: string;
  type: 'shared' | 'vps' | 'dedicated' | 'cloud' | 'email';
  price: number;
  price_monthly?: number;
  price_yearly?: number;
  billing_cycle?: 'monthly' | 'yearly';
  features: string[] | string;
  disk_space_gb?: number; // Legacy field name
  storage_gb?: number; // New field name
  bandwidth_gb: number;
  max_domains: number;
  max_email_accounts: number;
  max_databases?: number;
  cpu_cores?: number;
  ram_gb?: number;
  setup_fee?: number;
  support_level?: string; // Made optional since it might not always be present
  status: 'active' | 'inactive';
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface Subscription {
  id: string;
  customer_id: string;
  package_id: string;
  status: 'active' | 'suspended' | 'cancelled';
  billing_cycle: 'monthly' | 'yearly';
  price: number;
  start_date: string;
  end_date: string;
  auto_renew: boolean;
  created_at: string;
  updated_at: string;
}

export const hostingService = {
  async getPackages() {
    try {
      const response = await axios.get(getApiUrl('/hosting/packages'));
      const allPackages = response.data.data || [];
      
      // Only show actual shared/dedicated/cloud hosting packages
      const hostingPackages = allPackages.filter((pkg: any) => 
        ['shared', 'dedicated', 'cloud'].includes(pkg.type)
      );
      
      return { success: true, data: hostingPackages };
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Failed to fetch packages' };
    }
  },

  async getVPSPackages() {
    try {
      const response = await axios.get(getApiUrl('/hosting/packages/type/vps'));
      return { success: true, data: response.data.data || [] };
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Failed to fetch VPS packages' };
    }
  },

  async getEmailPackages() {
    try {
      const response = await axios.get(getApiUrl('/hosting/packages/type/email'));
      return { success: true, data: response.data.data || [] };
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Failed to fetch email packages' };
    }
  },

  async getSubscriptions() {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(getApiUrl('/hosting/subscriptions'), {
        headers: { Authorization: `Bearer ${token}` }
      });
      return { success: true, data: response.data };
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Failed to fetch subscriptions' };
    }
  },

  async createSubscription(data: {
    package_id: string;
    billing_cycle: 'monthly' | 'yearly';
  }) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(getApiUrl('/hosting/subscriptions'), data, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return { success: true, data: response.data };
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Failed to create subscription' };
    }
  },

  async cancelSubscription(subscriptionId: string) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(getApiUrl(`/hosting/subscriptions/${subscriptionId}/cancel`), {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return { success: true, data: response.data };
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Failed to cancel subscription' };
    }
  }
};